/* eslint-disable sonarjs/cognitive-complexity */
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import {
  MARKETING_CREDIT_INFO,
  PREFORMATTED_STRING,
  REDEEM_CODE_UNUSED_WOWCHER,
} from '../../../brands/default/content/components/checkout';
import { setUpWalletBalances } from '../../../helpers/credit';
import ThemeContext from '../../../providers/ThemeProvider';
import RedeemForm from '../../_generic/redeemForm/RedeemForm';
import DealInfoBox from '../../deal/shared-components/DealInfoBox';

const initialState = {
  hasError: false,
  isChecked: false,
  isTouchOrderNo: false,
  isTouchWowcherCode: false,
  orderNo: '',
  showConfirmation: false,
  showForm: false,
  showOverlay: false,
  showRedeem: false,
  validationData: {},
  wowcherCode: '',
};

const RedeemCode = ({
  currency,
  extraClasses,
  redeemCreditOnComplete,
  hasLoadingSpinner,
  paymentOptions,
  isWalletAllowed,
  totalWalletApplicableOrderAmount,
  walletIsApplied,
}) => {
  const theme = useContext(ThemeContext);
  const [redeemState, setRedeemState] = useState(initialState);
  const { showOverlay, showForm } = redeemState;
  const [showMarketingBalanceInfo, setMarketingBalanceInfo] = useState(true);
  const wowcherOrVoucher =
    PREFORMATTED_STRING.brandTerminology.wowcher_or_voucher;
  useEffect(() => {
    const creditInfo = paymentOptions?.creditBalances.find(
      (item) => item?.currency.toLowerCase() === currency.toLowerCase(),
    );
    const walletBalances = setUpWalletBalances({ paymentOptions });
    const hasWalletBalances = Object.keys(walletBalances).length > 0;
    const hasCreditInSameCurrency =
      hasWalletBalances && walletBalances[currency].totalBalance > 0;

    setMarketingBalanceInfo(
      creditInfo?.marketingBalance > 0 &&
        isWalletAllowed &&
        totalWalletApplicableOrderAmount &&
        hasCreditInSameCurrency,
    );
  }, [
    currency,
    totalWalletApplicableOrderAmount,
    paymentOptions,
    isWalletAllowed,
  ]);

  const toggleOverlay = () => {
    setRedeemState({
      ...redeemState,
      hasError: false,
      isChecked: false,
      isTouchOrderNo: false,
      isTouchWowcherCode: false,
      orderNo: '',
      showForm: !showForm,
      showOverlay: !showOverlay,
      wowcherCode: '',
    });
  };

  return (
    <div className={classNames('redeem-code', extraClasses)}>
      <button
        className="redeem-code__link"
        onClick={() => toggleOverlay()}
        type="button"
      >
        {REDEEM_CODE_UNUSED_WOWCHER(wowcherOrVoucher)}
      </button>
      <div className="deal__info-box">
        <DealInfoBox
          iconPosition="left"
          isArrowVisible={false}
          show={showMarketingBalanceInfo && walletIsApplied}
        >
          {MARKETING_CREDIT_INFO}
        </DealInfoBox>
      </div>
      {showOverlay && (
        <div className="redeem-code__overlay">
          <FontAwesomeIcon
            className="redeem-code__close"
            icon={faTimes}
            onClick={() => toggleOverlay()}
          />
          <RedeemForm
            currency={currency}
            hasLoadingSpinner={hasLoadingSpinner}
            redeemCreditOnComplete={redeemCreditOnComplete}
            showForm={showForm}
          />
        </div>
      )}
      <style jsx>{`
        .redeem-code {
          position: relative;
        }
        .redeem-code__link {
          display: block;
          color: ${theme.colors.primary};
          margin-bottom: 10px;
          font-size: 85%;
          background: none;
          cursor: pointer;
          border: none;
          padding: 0;
        }
        .redeem-code__link:hover {
          cursor: pointer;
          color: #23527c;
        }
        .redeem-code__overlay {
          position: absolute;
          background: white;
          padding: 40px 25px 30px;
          z-index: 99;
          top: 30px;
          border: 1px solid #c7c7c7;
          border-bottom: 5px solid ${theme.colors.primary};
          box-shadow: 1px 1px 4px #b3b3b3;
          border-top: none;
          max-width: 320px;
          transition-property: all;
          transition-duration: 3s;
          transition-timing-function: cubic-bezier(0, 5, 0.5, 5);
        }
        .redeem-code :global(.redeem-code__close) {
          position: absolute;
          margin: 15px;
          top: 0px;
          right: 0px;
          line-height: 0;
          color: ${theme.colors.primary};
        }
        .redeem-code :global(.redeem-code__close):hover {
          cursor: pointer;
          color: #23527c;
        }
      `}</style>
    </div>
  );
};

RedeemCode.propTypes = {
  creditBalances: PropTypes.array,
  currency: PropTypes.string,
  extraClasses: PropTypes.string,
  hasLoadingSpinner: PropTypes.func,
  isWalletAllowed: PropTypes.bool,
  paymentOptions: PropTypes.object,
  redeemCreditOnComplete: PropTypes.func,
  totalWalletApplicableOrderAmount: PropTypes.number,
  walletIsApplied: PropTypes.bool,
};

RedeemCode.defaultProps = {
  hasLoadingSpinner: () => {},
  redeemCreditOnComplete: () => {},
};

export default RedeemCode;
